import React, {memo} from 'react';
import {graphql} from 'gatsby';

import PageElementGroup from '../components/page-element-group';

export const query = graphql `
	query PressPage {
		allPagesJson(filter: {slug: {eq: "press"}}) {
			nodes {
				...PageElementGroup
			}
		}
	}
`;

export default memo(
	/**
	 * @param {import("gatsby").PageProps<
	 *   import("../../tmp/graphql-types").PressPageQuery,
	 *   {
	 *     hashState: number,
	 *     meta: import("../page-metadata").PageMetadata,
	 *   }
	 * >} props
	 * @returns {React.ReactElement} ...
	 */
	function Press({data, pageContext: {hashState, meta}}) {
		return (
			<PageElementGroup
				name="main"
				meta={meta}
				nodes={data.allPagesJson.nodes}
				hashState={hashState}
			/>
		);
	}
);
